export default __webpack_public_path__ + "images/415b442ebb91b1c10ff3ddc2bdffbc29-engageAttendees.webp";